'use client'

import { useEffect, useState } from 'react'
import { User } from 'types/auth'
import { FlowTypeEnum, UserStatusEnum } from 'types/subscription'

import { getTrialRemainingTime } from '@/utils'

export function useShowTrialCountdown(
	user: User | null,
	showCountdown: boolean,
) {
	const [countdown, setCountdown] = useState(() =>
		user
			? getTrialRemainingTime(user.createdAt, user.flowData?.freeDaysQuota)
			: null,
	)

	useEffect(() => {
		if (
			countdown?.expired ||
			!showCountdown ||
			(user?.flow !== FlowTypeEnum.SOME_DAYS_FREE &&
				user?.status !== UserStatusEnum.FREEMIUM_NEW)
		)
			return

		const interval = setInterval(() => {
			setCountdown(
				getTrialRemainingTime(user.createdAt, user.flowData?.freeDaysQuota),
			)
		}, 60000)

		return () => clearInterval(interval)
	}, [user, countdown, showCountdown])

	return countdown
}
